import { useContext } from 'react';
import { ChatSessionContext } from './chatSessionContext';
import type { UseChatSessionResult } from './useChatSession';

export function useChat(): UseChatSessionResult {
  const ctx = useContext(ChatSessionContext);
  if (!ctx) throw new Error('useChat must be used within a ChatSessionProvider');
  return ctx;
}
